// Google OAuth 2.0 Web Client ID for TabTrips (Firebase project: tabtrips-19841).
// Replace with your client ID from Google Cloud Console > APIs & Services > Credentials > OAuth 2.0 Client ID (Web application).
export const GOOGLE_CLIENT_ID = '';
export const GOOGLE_LOGIN_ENABLED = Boolean(GOOGLE_CLIENT_ID);
